function InboundIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666666 4V10L6 13V7M0.666666 4L6 1L11.3333 4M0.666666 4L6 7M11.3333 4V7M11.3333 4L6 7M12.6667 11H8M8 11L10 9M8 11L10 13"
        stroke={!isActive ? '#828282' : '#FFFFFF'}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default InboundIcon
